import React from "react";
import { Navigate, Outlet, Route, useLocation } from "react-router";
import PropTypes from "prop-types";
import { PATH } from "../../constants/appConstants";

const ProtectedRoute = ({
  component: Component,
  validator, // condition in which it should remain on the page
  redirectTo, // its a string where it needs to navigate if present
  history,
  ...rest
}) => {
  console.log(validator());
  return validator() ? <Component /> : <Navigate to={PATH.LOGIN_SCREEN} />;
};


ProtectedRoute.propTypes = {
  component: PropTypes.func.isRequired,
  validator: PropTypes.func.isRequired,
};

export default ProtectedRoute;
